import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Search } from '@mui/icons-material';
import { TextField, IconButton } from '@totalsoft/rocket-ui';

const AllowedStateListFiltersComponent = ({ listFilter, onListFilterChanged }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} justifyContent='flex-end'>
      <Grid item xs={6} sm={6} md={6}>
        <TextField
          fullWidth
          label={t('DocumentTypes.State')}
          value={listFilter.stateFilter}
          onChange={e => onListFilterChanged('stateFilter', e)}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              type='cancel'
              fontSize='medium'
              color='transparent'
              tooltip={t('Tooltips.ResetFilters')}
              onClick={() => onListFilterChanged('stateFilter', '')}
            />
          }
        />
      </Grid>
      <Grid item xs={6} sm={6} md={6}>
        <TextField
          fullWidth
          label={t('UserGroups.Title')}
          value={listFilter.userGroupFilter}
          onChange={e => onListFilterChanged('userGroupFilter', e)}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              type='cancel'
              fontSize='medium'
              color='transparent'
              tooltip={t('Tooltips.ResetFilters')}
              onClick={() => onListFilterChanged('userGroupFilter', '')}
            />
          }
        />
      </Grid>
    </Grid>
  );
};

AllowedStateListFiltersComponent.propTypes = {
  listFilter: PropTypes.object.isRequired,
  onListFilterChanged: PropTypes.func.isRequired
};

export default memo(AllowedStateListFiltersComponent);
